module.exports = __webpack_public_path__ + "img/logo-dark.c70dd76b.png";